import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideFilterComponent } from './side-filter.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { translateServerLoaderFactory } from '@app-utils/translate-server-loader';
import { SharedComponentsModule } from '../shared-components.module';

@NgModule({
	declarations: [SideFilterComponent],
	imports: [
		CommonModule,
		MatButtonModule,
		MatDividerModule,
		MatCheckboxModule,
		SharedComponentsModule,
		FormsModule,
		TranslateModule.forChild({
			loader: {
				provide: TranslateLoader,
				useFactory: translateServerLoaderFactory,
				deps: [HttpClient]
			}
		})
	],
	exports: [SideFilterComponent]
})
export class SideFilterModule {}
